export const TAGS_CONSTS = {
    GET_TAGS: "GET_TAGS",
    ADD_TAGS: "ADD_TAGS",
    UPDATE_TAGS: "UPDATE_TAGS",
    DELETE_TAGS: "DELETE_TAGS",
};
